import React from "react"
import like from '../../img/icon/like.png';

export default function Like() {
   return (
     <img src={like} alt="" />
   )
}
